import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {provideHttpClient} from "@angular/common/http";
import {ENV, getEnv} from "./environments/environment.provider";

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes), provideHttpClient(), {provide: ENV, useFactory: getEnv}]
};
